import type {CreativePlacementSpec} from '../../../common/constants/creativeAssetSpecs'

/** Absolute-position style (in %) of the safe area inside a canvas-sized wrapper. */
export const safeAreaStyle = ({width, height, safeArea}: CreativePlacementSpec) => ({
  left: `${((width - safeArea.width) / 2 / width) * 100}%`,
  top: `${(((height - safeArea.height) / 2 + safeArea.offsetY) / height) * 100}%`,
  width: `${(safeArea.width / width) * 100}%`,
  height: `${(safeArea.height / height) * 100}%`,
})
